document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-waitlist-popup]');
  const closeButtons = document.querySelectorAll('[data-waitlist-close]');

  if (!popup) return;

  const openPopup = () => {
    popup.classList.add('is-active');
    document.body.classList.add('waitlist-popup-open');

    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });
  };

  const closePopup = () => {
    popup.classList.remove('is-visible');
    document.body.classList.remove('waitlist-popup-open');

    setTimeout(() => {
      popup.classList.remove('is-active');
    }, 350);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '.waitlist-trigger, a[href="#join-waitlist"], button[name="join-waitlist"]'
    );

    if (!trigger) return;

    event.preventDefault();
    openPopup();
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;

  if (
    urlParams.get('customer_posted') === 'true' ||
    hash === '#WaitlistPopupForm' ||
    hash === '#contact_form'
  ) {
    openPopup();

    if (history.replaceState) {
      history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );
    }
  }
});